/**
 * Добавляет параметр size к URL изображений из REST /api/images.
 * Бэкенд отдаёт URL без size — подставляем на фронте.
 */
const IMAGE_SIZES = ['sx', 'sm', 'md', 'lg', 'xl'] as const;
export type ImageSize = (typeof IMAGE_SIZES)[number];

export function withImageSize(url: string, size: ImageSize = 'md'): string {
  if (!url || typeof url !== 'string') return url || '';
  if (!url.includes('/api/images/')) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}size=${size}`;
}
